import { ThemeProvider } from '@emotion/react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { StylesProvider, createGenerateClassName } from '@mui/styles'
import { getTheme } from './getTheme'

const generateClassName = createGenerateClassName({
  productionPrefix: 'c',
  disableGlobal: true,
})

export const Theme = ({ children, overrides = {} }) => {
  const theme = getTheme()
  const themeOverrides = ancestorTheme => ({ ...ancestorTheme, ...overrides })
  return (
    <ThemeProvider theme={theme}>
      <ThemeProvider theme={themeOverrides}>
        <StylesProvider generateClassName={generateClassName}>
          <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </StylesProvider>
      </ThemeProvider>
    </ThemeProvider>
  )
}
